<template>
  <div>
    <b-row align-h="center" class="mt-0 pt-0">
      <div class="w-75">
        <FITFormCard>
          <div slot="header">
            <b-row align-v="center">
              <b-col cols="6">
                <h4>{{ $t('osm.renewal.renewLife.header')}}</h4></b-col>
              <b-col cols="auto" class="ml-auto">
                <!-- <FITButton size="md" :text="$t('general.CURD.delete')" variant="danger" @click="onClickDelete"></FITButton> -->
              </b-col>
            </b-row>
          </div>
          <div slot="formBody">
            <div>
              <RenewLifeComponent v-model="form" :detail="detail"></RenewLifeComponent>
              <!-- <b-row>
                <b-col cols="6">
                  <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.productName')" :width="8" type="text" :disabled="true" :value="detail.productEnglishName + detail.productChineseName"></FITTextInput>
                  <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.modalPremium')" :width="8" type="text" v-model="form.modalPremium"></FITTextInput>
                  <FITDatePicker :label="$t('osm.renewal.renewLife.actualPaymentDate')" v-model="form.actualPaymentDate" :width="8"></FITDatePicker>
                </b-col>
                <b-col cols="6">
                  <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.policyNumber')" v-model="detail.policyNumber" :width="8" type="text" :disabled="true"></FITTextInput>
                  <FITTextInput :label="$t('osm.renewal.renewLife.period')" :width="8" type="number" v-model="form.period"></FITTextInput>
                </b-col>
                <b-col cols="6">
                  <FITSelect :label="$t('osm.contents.lifePolicy.generalInformation.paymentMethod')" :width="8" :options="getTranslated(`${$i18n.locale}`,'Renewal','paymentMethod')" v-model="form.paymentMethod"></FITSelect>
                </b-col>
                <b-col cols="6">
                  <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.paymentReference')" v-model="form.paymentReference" :width="8" type="text"></FITTextInput>
                </b-col>
              </b-row> -->
            </div>
            <b-row>
              <b-col class="text-right">
                <FITButton size="md" :text="$t('general.submit')" variant="primary" @click="submit"></FITButton>
              </b-col>
            </b-row>
          </div>
        </FITFormCard>
      </div>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import RenewLifeComponent from '../components/RenewLifeComponent'
import { mapGetters, mapState } from 'vuex'
import { FITFormCard, FITTextInput, FITTextarea, FITButton, FITModal, FITAutoSearch, FITSelect, FITDatePicker } from '@/components'
import moment from 'moment'
export default {
  name: 'RenewLife',
  components: {
    RenewLifeComponent,
    FITFormCard,
    FITTextInput,
    FITTextarea,
    FITButton,
    FITModal,
    FITAutoSearch,
    FITSelect,
    FITDatePicker
  },
  created() {
    if (this.detail) {
      Vue.set(this.form, 'policyID', this.detail.policyID);
      Vue.set(this.form, 'modalPremium', this.detail.modalPremium);
      Vue.set(this.form, 'period', 1);
      Vue.set(this.form, 'actualPaymentDate', moment().format('YYYY-MM-DD'));
      Vue.set(this.form, 'policyNumber', this.detail.policyNumber);
    }
    this.$store.dispatch('getAllSelections', 'renewal')
      .then((json) => {
        this.$store.commit({ type: 'Renewal/setSelections', selections: json.data });
      })
      .catch((err) => {
        console.error(err);
      })
  },
  methods: {
    submit() {
      Vue.set(this.form, 'paymentAmount', this.form.modalPremium);
      Vue.set(this.form, 'paymentDate', this.form.actualPaymentDate);
      this.$store.dispatch('Renewal/renewLife', this.form).then((json) => {
        this.$router.replace({ name: 'Life Policy List', params: { alertContent: this.$t('general.updateSuccess'), alertVariant: 'success' } });
      }).catch((error) => {
        console.debug(error);
      })
    },
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(['getTranslated']),
  },
  data() {
    return {
      form: {
        policyID: -1,
        modalPremium: 0,
        period: 0,
        actualPaymentDate: '',
        policyType: 'P',
        paymentMethod: '',
        companyBank: '',
        paymentReference: '',
        paymentDate: '',
        paymentStartDate: '',
        paymentEndDate: '',
        paymentAmount: 0,
      },
      selectedProvider: { ID: -1 },
    }
  },
}

</script>



// WEBPACK FOOTER //
// src/Osm/Renewal/containers/RenewLife.vue